<template>
  <div class="table-container">
    <table class="table is-fullwidth is-narrow is-hoverable">
      <thead>
        <tr class="is-unselectable">
          <th @click="$emit('order', 'friendlyName')">Name</th>
          <th @click="$emit('order', 'shared')">Owner</th>
          <th @click="$emit('order', 'permission')">Permissions</th>
          <th @click="$emit('order', 'sharedWithOthers')">Shared</th>
        </tr>
      </thead>
      <TableEffect>
        <tr v-for="domain of items" :key="domain.uid">
          <td>
            <div
              @contextmenu.prevent="
                $emit('menu', { e: $event, domain: domain })
              "
            >
              <router-link v-if="!domain.edit" :to="`/domains/${domain.uid}`">
                <span class="icon is-small margin-right-5">
                  <i class="mdi mdi-domain" aria-hidden="true"></i>
                </span>
                <span>{{ domain.friendlyName }}</span>
              </router-link>
              <EditSingleField
                v-if="domain.edit"
                :text="domain.friendlyName"
                validation="required"
                type="text"
                name="name"
                @save="$emit('save', { domain: domain, text: $event })"
                @cancel="$emit('cancel', domain)"
                :isLoading="domain.saving"
              ></EditSingleField>
            </div>
          </td>
          <td>{{ domain.shared ? "No" : "Yes" }}</td>
          <td>{{ permission(domain) }}</td>
          <td>{{ domain.sharedWithOthers ? "Yes" : "No" }}</td>
        </tr>
      </TableEffect>
    </table>
  </div>
</template>

<script>
import permissions from "@/utils/permission.js";

export default {
  props: { items: Array },
  components: {
    TableEffect: () => import("@/components/singles/TableEffect.vue"),

    EditSingleField: () =>
      import("@/components/singles/EditSingleField/component.vue"),
  },
  computed: {
    permission() {
      return (domain) => {
        if (domain.permission) return permissions.domain[domain.permission];
        else return "Owner";
      };
    },
  },
};
</script>
